import {
  GET_INTRANSIT_REPORT_REQUEST,
  GET_INTRANSIT_REPORT_SUCCESS,
  GET_INTRANSIT_REPORT_ERROR,
} from "../actions/types";

export const intransit = (state = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_INTRANSIT_REPORT_REQUEST:
      return {
        loading: true,
      };
    case GET_INTRANSIT_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_INTRANSIT_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    default: {
      return state;
    }
  }
};
